import { Container } from '@/components/layout/Container';
import VizyTextPage from '@/components/vizy/VizyTextPage';
import { LegalTextPageFragment } from '@/graphql';

interface LegalTextPageProps {
  entry: LegalTextPageFragment;
}

const LegalTextPage: PageTemplate<LegalTextPageProps> = ({ entry }) => {
  return (
    <Container>
      <VizyTextPage rawNodes={entry?.textPageContent?.rawNodes} nodes={[]} />
    </Container>
  );
};

export default LegalTextPage;
